import React from 'react';
import PropTypes from 'prop-types';

import { Image } from 'semantic-ui-react';
import {
  flattenHTMLToAppURL,
  flattenToAppURL,
} from '@plone/volto/helpers/Url/Url';

const DayExpanded = ({ day, showLeadImage = true, children, className }) => {
  return (
    <section className={`day ${className ? className : ''}`}>
      {day?.image?.scales?.large?.download && showLeadImage && (
        <figure>
          <Image
            src={flattenToAppURL(day.image.scales.large.download)}
            alt=""
            loading="lazy"
          />
          <div className="image-caption">{day.image_caption}</div>
        </figure>
      )}
      <h2>{day.title}</h2>

      {(day?.description || day?.text || day?.itinerary_map) && (
        <div className="day-content-wrapper">
          {(day?.description || day?.text) && (
            <div className="day-content">
              {day?.description && (
                <div className="description">{day?.description}</div>
              )}
              {day?.text && (
                <div
                  className="text"
                  dangerouslySetInnerHTML={{
                    __html: flattenHTMLToAppURL(day?.text?.data),
                  }}
                />
              )}
            </div>
          )}

          {day?.itinerary_map && (
            <div className="itinerary-map">
              <div
                dangerouslySetInnerHTML={{
                  __html: day?.itinerary_map,
                }}
              />
            </div>
          )}
        </div>
      )}

      {children}
    </section>
  );
};

DayExpanded.propTypes = {
  day: PropTypes.object.isRequired,
};

export default DayExpanded;
